import BaseApiRequest from "./BaseApiRequest";
import { METHOD } from "../Constants";
import { INVERITE_FETCH_API_URL } from "../ApiUrls";

export default class FetchInveriteRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return INVERITE_FETCH_API_URL;
  };

  getBody = () => {
    return this.body;
  };
}
